import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";

export const RIE_ROLES = [
  {
    icon: SupervisorAccountOutlinedIcon,
    title: "RIE Coordinator",
    tagline: "Coordinates the RIE.",
    desc: "The person or organisation responsible for coordinating the activities of the Rural Innovation Ecosystem.",
  },
  {
    icon: CampaignOutlinedIcon,
    title: "Local Communication Manager",
    tagline: "Manages local communication.",
    desc: "A member of the RIE community responsible for managing communication at the local level.",
  },
  {
    icon: GroupsOutlinedIcon,
    title: "Local Task Force",
    tagline: "Drives active involvement.",
    desc: "A group of selected stakeholders who are most actively involved in the RIE through their expertise, interests or potential benefit from co-development activities.",
  },
  {
    icon: RecordVoiceOverOutlinedIcon,
    title: "Local Influencer",
    tagline: "Connects with the community.",
    desc: "A stakeholder who is actively involved in community activities or has particular influence within the community.",
  },
  {
    icon: PublicOutlinedIcon,
    title: "RIE Community",
    tagline: "Represents the wider community.",
    desc: "The stakeholders engaged in the project, representing civil society and including groups at risk of social exclusion or under-representation.",
  },
];

export const RIE_PLACES = [
  {
    icon: MapOutlinedIcon,
    title: "RIE Territory",
    tagline: "The geographical area of the RIE.",
    desc: "The geographical area of application of the solutions that are co-developed within the RIE. The territory of application of the solution might not coincide with the RIE geographies.",
  },
  {
    icon: FmdGoodOutlinedIcon,
    title: "RDD Geography",
    tagline: "The area where each RDD solution is applied.",
    desc: "The geographical area that includes the territory where the solution linked to a specific RDD is applied and locations of the pool of stakeholders involved in the co-development project. Its size and position depend on the solution itself and on the stakeholders involved. The number of RDD geographies corresponds to the number of RDDs chosen to be addressed; the overlapping of RDD geographies makes up the RIE geography.",
  },
  {
    icon: HomeWorkOutlinedIcon,
    title: "RIE Site(s)",
    tagline: "Where the community meets and collaborates.",
    desc: "Venue(s) where the RIE community, RIE coordinator and Local Task Forces meet to attend workshops, discuss, and co-develop innovative solutions.",
  },
];

export const RIE_PRACTICES = [
  {
    icon: DesignServicesOutlinedIcon,
    title: "Co-design & Co-development",
    tagline: "Developing solutions together.",
    desc: "Collaborative workshops and sessions where RIE members work together to design and develop innovative solutions tailored to local rural challenges.",
  },
  {
    icon: SchoolOutlinedIcon,
    title: "Knowledge Sharing",
    tagline: "Learning from each other.",
    desc: "Exchanging expertise, experiences and best practices across the RIE community to strengthen local capacity and inform decision-making.",
  },
  {
    icon: PrecisionManufacturingOutlinedIcon,
    title: "Community Engagement",
    tagline: "Involving the wider community.",
    desc: "Activities and outreach methods that bring community members into the RIE process, ensuring inclusive participation and broad ownership of outcomes.",
  },
];

export default RIE_ROLES;
